import React, { useContext, useState } from "react";
import { useTranslation } from "react-i18next";
import FormDataContext from "integrations/contexts/FormDataContext";
import fetch from "logic/rest/FetchProvider";
import { qualifyUrl } from "util/URLUtils";
import { ApiRoutes } from "./Routes";
import ValidatedInput from "../common/ValidatedInput";
import FormWrap from "../common/FormWrap";
import formValidation from "../common/utils/formValidation";
import handleFileUpload from "../helpers/fileReader";
const StepAuthorize = ({ onSubmit, onChange }) => {
  var _a;
  const { t } = useTranslation("enterprise_integrations");
  const { formData } = useContext(FormDataContext);
  const [formError, setFormError] = useState(null);
  const handleSubmit = () => {
    var _a2;
    fetch("POST", qualifyUrl(ApiRoutes.INTEGRATIONS.WorkspaceV2.CHECK_CREDENTIALS), {
      service_account_key: ((_a2 = formData == null ? void 0 : formData.serviceAccountKey) == null ? void 0 : _a2.fileContent) || ""
    }).then((result) => {
      if (result.result === "valid") {
        setFormError(null);
        onSubmit();
      } else {
        setFormError({
          full_message: result.result,
          nice_message: t("googleworkspacev2.errors.unable_to_connect")
        });
      }
    }).catch((err) => {
      setFormError({
        full_message: err.message,
        nice_message: t("googleworkspacev2.errors.unable_to_connect")
      });
    });
  };
  const onFileUpload = (e) => {
    e.persist();
    handleFileUpload(e.target.files[0], (fileName, fileContent) => onChange(e, { fileName, fileContent }));
  };
  const accountKeyHelpText = ((_a = formData.serviceAccountKey) == null ? void 0 : _a.fileName) ? t("googleworkspacev2.authorize.currently_using_file", { fileName: formData.serviceAccountKey.fileName }) : t("googleworkspacev2.authorize.service_account_key_help");
  const isFormValid = formValidation.isFormValid(
    ["workspaceName", "serviceAccountKey", "workspaceDatasetName"],
    formData
  );
  return /* @__PURE__ */ React.createElement(
    FormWrap,
    {
      onSubmit: handleSubmit,
      buttonContent: t("googleworkspacev2.authorize.verify_and_proceed"),
      disabled: isFormValid,
      title: "",
      className: "col-md-7",
      error: formError,
      description: ""
    },
    /* @__PURE__ */ React.createElement(
      ValidatedInput,
      {
        id: "workspaceName",
        type: "text",
        fieldData: formData.workspaceName,
        onChange,
        placeholder: t("common.fields.input_name"),
        label: t("common.fields.input_name"),
        autoComplete: "off",
        help: t("common.fields.input_name_help"),
        required: true
      }
    ),
    /* @__PURE__ */ React.createElement(
      ValidatedInput,
      {
        id: "serviceAccountKey",
        type: "file",
        onChange: onFileUpload,
        fieldData: formData.serviceAccountKey,
        label: t("googleworkspacev2.authorize.service_account_key"),
        help: accountKeyHelpText,
        accept: ".json",
        required: true
      }
    ),
    /* @__PURE__ */ React.createElement(
      ValidatedInput,
      {
        id: "workspaceDatasetName",
        type: "text",
        onChange,
        fieldData: formData.workspaceDatasetName,
        help: t("googleworkspacev2.authorize.dataset_name_help"),
        label: t("googleworkspacev2.authorize.dataset_name"),
        required: true
      }
    )
  );
};
export default StepAuthorize;
